export default "__VITE_ASSET__D0xb6tmg__"